import styled from 'styled-components';

const ButtonWrapper = styled.div`
  cursor: pointer;
  margin: ${({ isDesktop, margin }) => margin || (isDesktop ? '0' : '5% 2%')};
  ${({ noMaxWidth }) => (noMaxWidth ? null : 'max-width: 500px;')} text-align: center;
`;

export default ButtonWrapper;
